<template>
  <div>

    <b-card
      no-body
      class="mb-1"
      v-for="(item, index) in qualifications"
      :key="uniqueId(item.id)"
    >
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button
          block
          v-b-toggle="'accordion-qualification-' + index"
          variant="info"
        >
          <span v-if="!item.isCompleted">Current Qualification</span>
          <span v-if="item.isCompleted">Qualification {{getDate(item.createdDateTime)}}</span>
        </b-button>
      </b-card-header>
      <b-collapse
        :id="'accordion-qualification-' + index"
        visible
        accordion="accordion"
        role="tabpanel"
      >
        <b-card-body>
          <b-card-text>
            <CompanyUnbookedEntry
             :initialQualification="item"
             :lookups="lookups"
             :index="index" />
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>


<!--
    <b-card no-body class="mb-1" v-for="(item, index) in items" :key="item.message">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle="'accordion-qualification-' + index" variant="info">
          Qualification {{index}}
        </b-button>
      </b-card-header>
      <b-collapse
        :id="'accordion-qualification-' + index"
        visible
        accordion="accordion"
        role="tabpanel">
        <b-card-body>
          <b-card-text>

          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card> -->

  </div>
</template>

<script>
import CompanyUnbookedEntry from "@/components/company/unbooked/CompanyUnbookedEntry.vue";
import { format } from 'date-fns'

export default {
  components: { CompanyUnbookedEntry },
  props: {
    qualifications: Array,
    lookups: Object
  },
  data() {
    return {
      uniqueIdStart: 0
    }
  },
  watch: {
    qualifications: function() {
      console.log("unbooked", this.uniqueIdStart, this.qualifications)
      if(this.qualifications.length> 0) {
        this.uniqueIdStart += 1;
      }
    }
  },
  methods: {
    getDate(date) {
      if(date == null) return "";
      return format(new Date(date), "dd/MM/yyyy HH:mm")
    },
    uniqueId(id) {
      return this.uniqueIdStart + '-' + id;
    }
  },
};
</script>


<style scoped>
.table {
  font-size: 0.85em;
}

.label {
  text-align: right;
}
.label > label {
  margin-top: 6px;
}
</style>

